'use client';

import { getBackground } from '@/theme/backgrounds';
import React, { useEffect, useState } from 'react';
import {
  StrapiComponentBackground,
  StrapiTextSubText,
} from '../section/interfaces';
import Heading from '../common/Heading';
import {
  TextWithDropShadowColor,
  TextWithDropShadow,
} from '../TextWithDropShadow';

interface ComponentProps3D {
  isTitle: boolean;
  isSubtext: boolean;
  title: StrapiTextSubText;
  subtext?: StrapiTextSubText;
  background?: StrapiComponentBackground;
  models: { label: string; poster: string; url: string }[];
}

const ModelViewer3D: React.FC<ComponentProps3D> = ({
  isTitle,
  isSubtext,
  title,
  subtext,
  background,
  models = [
    {
      label: "Size 16'",
      poster:
        'https://res.cloudinary.com/dbkbadq4w/image/upload/q_auto/f_auto/v1744639343/web/mrcool.com/HVLS/5-Blade-poster',
      url: 'https://res.cloudinary.com/dbkbadq4w/image/upload/v1743696754/Cloudinary%203D/models/HVLS_Fan_5B_Web_5-5-25_eldqlw.glb',
    },
    {
      label: "Size 24'",
      poster:
        'https://res.cloudinary.com/dbkbadq4w/image/upload/q_auto/f_auto/v1744639344/web/mrcool.com/HVLS/6-Blade-poster',
      url: 'https://res.cloudinary.com/dbkbadq4w/image/upload/v1743001261/Cloudinary%203D/models/HVLS_Fan_6B_For_Web_5-8-25_lh41pe.glb',
    },
  ],
}) => {
  const titleSize = (title && title.size?.size.match(/\d+/)?.[0]) || '3';
  const subtextSize = (subtext && subtext.size?.size.match(/\d+/)?.[0]) || '5';

  const titleColor: TextWithDropShadowColor = {
    text: title?.color?.color || 'text-white',
    shadow: 'text-white',
  };
  const subtextColor: TextWithDropShadowColor = {
    text: subtext?.color?.color || 'text-white',
    shadow: 'text-white',
  };

  const backgroundStyle = background?.url
    ? {
        backgroundImage: `url(${background.url})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
      }
    : { background: background?.style && getBackground(background?.style) };

  useEffect(() => {
    import('@google/model-viewer');
  }, []);

  const [currentModel, setCurrentModel] = useState(models[1]);

  return (
    <div
      className='flex w-full flex-col items-center justify-center p-4'
      style={backgroundStyle}
    >
      <div className='flex w-full flex-col gap-y-6 p-7 text-center'>
        {title && !title.hidden && title.text && (
          <Heading size={titleSize}>
            <TextWithDropShadow
              text={title.text}
              color={titleColor}
              displayShadow={title.shadow}
            />
          </Heading>
        )}
        {subtext && !subtext.hidden && subtext.text && (
          <Heading size={subtextSize}>
            <TextWithDropShadow
              text={subtext.text}
              color={subtextColor}
              displayShadow={subtext.shadow}
            />
          </Heading>
        )}
      </div>

      <div className='mb-6 flex gap-4'>
        {models.map((model) => (
          <button
            key={model.label}
            onClick={() => setCurrentModel(model)}
            className={`rounded-full border px-4 py-2 ${
              currentModel.label === model.label
                ? 'border-black bg-white text-black'
                : 'bg-white text-black'
            }`}
          >
            {model.label}
          </button>
        ))}
      </div>

      <model-viewer
        key={currentModel.url}
        src={currentModel.url}
        alt={currentModel.label}
        ar
        ar-modes='webxr scene-viewer quick-look'
        camera-controls
        auto-rotate
        tone-mapping='neutral'
        poster={currentModel.poster}
        shadow-intensity='1'
        field-of-view='45deg'
        style={{ width: '100%', height: '658px', maxWidth: '1000px' }}
      ></model-viewer>
    </div>
  );
};

export default ModelViewer3D;
